import { render, staticRenderFns } from "./WebsiteNewsAdmin.vue?vue&type=template&id=7029eb6f&scoped=true"
import script from "./WebsiteNewsAdmin.vue?vue&type=script&lang=js"
export * from "./WebsiteNewsAdmin.vue?vue&type=script&lang=js"
import style0 from "./WebsiteNewsAdmin.vue?vue&type=style&index=0&id=7029eb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029eb6f",
  null
  
)

export default component.exports